import './ModelListItem.scss';

export { default } from './ModelListItem';
